export const GTM_ID = "GTM-WQFF3P23";
export const ENABLE_MY_PRIVACY_CHOICE = true;
